import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getData } from '../helpers/api';

export default function Authenticate({Component, role}) {
	const user = useSelector(state => state.user)
	const dispatch = useDispatch()

	const token = localStorage.getItem('token')
	useEffect(() => {
		if (token && !user._id) {
			getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
				res.data.user.token = token
				dispatch({
					type: 'LOGIN_USER',
					user: res.data.user,
				});
				dispatch({
					type: 'USER_ORDERS',
					orders: res.data.orders,
				});
			}).catch(console.log)
		}
	}, [user]);
	if (!token) {
		return <Navigate to='/login' />
	}
	if (role && user.role && user.role !== role) return <Navigate to='/login' />
	if (!role && user.role) return Component;
	return (user.role === role)? Component : null
}